import { AHIcon, AHText, AHTextFonts, Box, TouchableBox } from "arkh";

import React from "react";
import { View } from "react-native";

import { Clock } from "../Clock/clock";
import { Wordmark } from "./Wordmark";
import { graphql, useFragment } from "react-relay";

import { StorecastPickerButton } from "@/src/OS/dashboard-picker/TVDashboardPickerButton";
import { StorecastHeaderTV_storecast$key } from "./__generated__/StorecastHeaderTV_storecast.graphql";

export const DashboardHeader = (props: {
  storecast: StorecastHeaderTV_storecast$key;
  onSelectDashboard: (dashboardId: string) => void;
  height: number;
}) => {
  const screen = useFragment(
    graphql`
      fragment StorecastHeaderTV_storecast on StorecastScreen {
        name
        inputMode
        store {
          name
          dashboards {
            ...TVDashboardPickerButton_dashboards
          }
        }
        dashboard(dashboardId: $dashboardId) @required(action: THROW) {
          id
          name
          ...TVDashboardPickerButton_dashboard
        }
      }
    `,
    props.storecast
  );
  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
        height: props.height,
        position: "relative",
        alignItems: "stretch",
      }}
    >
      <View
        style={{
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Box style={{ flexDirection: "row", alignItems: "center" }}>
          <AHText type="subtitle" color="text-secondary">
            {screen.store?.name ?? ""} - {screen.name ?? ""}{" "}
          </AHText>
          {screen.inputMode === "TOUCH" ? (
            <AHIcon
              spaceLeft="xsmall"
              type="touch"
              size="small"
              color="text-secondary"
            />
          ) : null}
        </Box>
        {screen.inputMode === "TOUCH" ? (
          <StorecastPickerButton
            currentDashboard={screen.dashboard}
            onChangeDashboard={({ id }) => props.onSelectDashboard(id)}
            isCompact={false}
            dashboards={screen.store?.dashboards ?? []}
          >
            {(onPress) => (
              <TouchableBox
                onPress={onPress}
                style={{ flexDirection: "row", alignItems: "center" }}
              >
                <AHText type="title-big" font={AHTextFonts.BOLD}>
                  {screen.dashboard.name}
                </AHText>
                <AHIcon
                  spaceLeft="medium"
                  type="chevron-down"
                  size="small"
                  color="text-primary"
                />
              </TouchableBox>
            )}
          </StorecastPickerButton>
        ) : (
          <AHText type="title-big" font={AHTextFonts.BOLD}>
            {screen.dashboard.name}
          </AHText>
        )}
      </View>
      <View
        style={{
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <TouchableBox
          onPress={() => {
            window.location.reload();
          }}
          spaceRight="large"
        >
          <AHIcon type="update" size="small" color="text-secondary"></AHIcon>
        </TouchableBox>
        <Clock />

        <Box
          spaceHorizontal="large"
          style={{
            height: "100%",
            alignItems: "center",
          }}
          spaceVertical="large"
        >
          <Box style={{ height: "100%", width: 1 }} color="border-strong"></Box>
        </Box>
        <Box
          style={{
            height: "100%",
          }}
          spaceVertical="large"
        >
          <Wordmark />
        </Box>
      </View>
    </View>
  );
};
